// 12星座在恋爱中的特点数据

export const ZODIAC_DATA = {
  aries: {
    name: '白羊座',
    emoji: '♈',
    tags: ['热情主动', '冲动直接', '占有欲强', '嫉妒心重'],
    traits: '白羊座的你在恋爱中热情主动，占有欲强，希望成为伴侣生活的中心。你性格直爽，有时会因冲动而表现出强烈的嫉妒或控制行为。你渴望被关注和确认，不喜欢伴侣与异性过多接触。',
    advice: '学会控制冲动，给伴侣更多空间。当感到嫉妒时，先冷静思考再表达。你的热情是优势，但过度的占有可能让对方窒息。'
  },
  taurus: {
    name: '金牛座',
    emoji: '♉',
    tags: ['占有欲强', '情感依赖', '缺乏安全感', '忠诚稳定'],
    traits: '金牛座的你在恋爱中占有欲较强，将伴侣视为重要的情感财富。你希望关系稳定长久，对背叛零容忍。你可能会通过物质或陪伴来表达爱，但也容易因缺乏安全感而过度依赖或控制。',
    advice: '建立稳固的自我价值感，不要将全部安全感寄托在伴侣身上。学会信任，给予对方自由度。你的忠诚是优势，但要避免过度占有。'
  },
  gemini: {
    name: '双子座',
    emoji: '♊',
    tags: ['占有欲低', '自由随性', '情感独立', '社交广泛'],
    traits: '双子座的你在恋爱中占有欲相对较低，重视个人自由和空间。你善于社交，不太会限制伴侣的活动。但有时你的独立可能让伴侣感到被忽视，觉得你不够在乎。',
    advice: '虽然占有欲低是优势，但也要让伴侣感受到你的重视和专注。适度的关心和确认可以增强关系亲密度。平衡自由与亲密。'
  },
  cancer: {
    name: '巨蟹座',
    emoji: '♋',
    tags: ['情感依赖', '缺乏安全感', '占有欲强', '敏感多疑'],
    traits: '巨蟹座的你在恋爱中情感依赖度高，渴望深度的情感连接和安全感。你容易因伴侣的小变化而产生不安，需要频繁的确认和关注。你可能会因为过度敏感而误解伴侣的行为，产生嫉妒或控制倾向。',
    advice: '建立内在的安全感，不要完全依赖外部确认。学习情绪管理，避免过度解读。你的细腻是优势，但要避免让敏感变成焦虑和控制。'
  },
  leo: {
    name: '狮子座',
    emoji: '♌',
    tags: ['占有欲强', '控制欲明显', '嫉妒心重', '自尊心强'],
    traits: '狮子座的你在恋爱中自信热情，占有欲强，希望成为伴侣眼中唯一的焦点。你渴望被崇拜和重视，不能容忍被忽视或背叛。你可能会因为强烈的自尊心而表现出控制或嫉妒行为，希望伴侣把你放在第一位。你慷慨大方，愿意为爱人付出一切，但也期待同样的回报和专注。',
    advice: '学会分享注意力，不要要求伴侣把所有重心都放在你身上。给对方一些主权和决策权。真正的爱不是控制和占有，而是相互尊重。你的自信和热情是优势，但过度的占有欲可能让对方感到压力。'
  },
  virgo: {
    name: '处女座',
    emoji: '♍',
    tags: ['控制欲强', '完美主义', '缺乏安全感', '情感保守'],
    traits: '处女座的你在恋爱中追求完美和秩序，可能会有较强的控制倾向。你希望一切按照预期发展，对伴侣的行为有较高的期待和标准。你可能会因为完美主义而过度管控，或因为不安全感而需要掌控细节。',
    advice: '接受关系中的不完美和不确定性。放下过度的控制欲，给伴侣犯错和成长的空间。学会信任和放手，完美的关系是双方共同成长的过程。'
  },
  libra: {
    name: '天秤座',
    emoji: '♎',
    tags: ['占有欲适中', '追求平衡', '情感独立', '理性温和'],
    traits: '天秤座的你在恋爱中追求平衡和和谐，占有欲通常处于适中水平。你能够理性地看待关系，既重视伴侣也保持独立。但有时你可能过于追求表面和平，压抑真实的不安或嫉妒情绪。',
    advice: '诚实表达你的感受，包括不安和嫉妒。真正的和谐不是压抑情绪，而是坦诚沟通。你的平衡感是优势，继续保持理性与情感的平衡。'
  },
  scorpio: {
    name: '天蝎座',
    emoji: '♏',
    tags: ['占有欲极强', '控制欲明显', '嫉妒心强', '情感深沉'],
    traits: '天蝎座的你在恋爱中占有欲和控制欲都很强，对伴侣有强烈的独占需求。你情感深沉，一旦投入就希望对方全心全意。你可能会监控伴侣的行为，对背叛零容忍，嫉妒心很强。你的占有源于深度的情感投入和对失去的恐惧。',
    advice: '学会信任，控制极端的占有欲和嫉妒。给伴侣呼吸的空间，真正的忠诚来自自愿而非监控。你的深情是优势，但要避免让爱变成控制和束缚。'
  },
  sagittarius: {
    name: '射手座',
    emoji: '♐',
    tags: ['占有欲低', '自由随性', '情感独立', '不喜束缚'],
    traits: '射手座的你在恋爱中占有欲较低，热爱自由，也给予伴侣充分的空间。你不喜欢被束缚，也不会过度束缚对方。但有时你的独立可能让伴侣感到被忽视，觉得你不够投入或在乎。',
    advice: '虽然自由很重要，但也要让伴侣感受到被重视。适度的关心和确认可以增强亲密度。平衡自由与承诺，让对方感到安全。'
  },
  capricorn: {
    name: '摩羯座',
    emoji: '♑',
    tags: ['控制欲较强', '情感保守', '责任感强', '缺乏表达'],
    traits: '摩羯座的你在恋爱中较为保守和传统，可能会有控制倾向但表现较为隐蔽。你通过实际行动表达爱，但可能缺乏情感表达和确认。你希望关系按照计划发展，对不确定性感到不安。',
    advice: '学会表达情感和脆弱，不要只用控制来获得安全感。开放地沟通你的需求和恐惧。你的责任感是优势，但要避免让关系变得过于刻板和缺乏温度。'
  },
  aquarius: {
    name: '水瓶座',
    emoji: '♒',
    tags: ['占有欲低', '情感独立', '理性客观', '不善表达'],
    traits: '水瓶座的你在恋爱中占有欲很低，重视精神独立和个人空间。你理性客观，不太会因嫉妒而失控。但你的疏离可能让伴侣感到不被重视，觉得你不够投入或关心。',
    advice: '虽然独立是优势，但关系需要情感投入和表达。让伴侣知道你的在乎，适度的占有欲可以增强亲密感。平衡理性与情感。'
  },
  pisces: {
    name: '双鱼座',
    emoji: '♓',
    tags: ['情感依赖', '缺乏安全感', '敏感多疑', '浪漫梦幻'],
    traits: '双鱼座的你在恋爱中情感依赖度高，渴望融入式的亲密关系。你敏感多疑，容易因为伴侣的小变化而产生不安和嫉妒。你可能会为了维持关系而牺牲自我，或通过情感勒索来挽留对方。你的占有源于对爱的渴望和对失去的恐惧。',
    advice: '建立清晰的关系边界，保持自我独立性。不要将全部幸福寄托在伴侣身上。学习自我关怀和情绪调节。你的浪漫是优势，但要避免让依赖变成负担。'
  }
};

export const getZodiacInfo = (zodiacKey) => {
  return ZODIAC_DATA[zodiacKey] || null;
};
